<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-info mb-5 text-uppercase pl-5">Licences Consultation</h3>
      <p class="card-description">
        Ajoutez des abonnements lecture seule supplémentaires en complément des {{ planConsults }} déjà inclus dans votre offre
      </p>
      <div v-if="currentConsultPacks" class="my-3">
        Abonnement actuel : <b class="text-info">{{ currentConsultPacks }} pack{{ currentConsultPacks > 1 ? 's' : '' }} de 10</b>
      </div>
      <!-- Card choosing -->
      <div class="border border-info">
        <div class="card-body p-0">
          <h5 class="mx-3 text-info border-bottom border-info text-uppercase d-flex align-items-center justify-content-center" style="height: 4.5rem">
            Pack de 10 licences consultation
          </h5>
          <div>
            <h4 class="text-center font-weight-bold text-dark mt-6" style="font-size: 1.5rem">
              {{ annualPremiumPlan ? '480 €' : '48 €' }}
              <span style="font-size: initial">HT / pack de 10</span>
            </h4>
            <p class="text-center text-muted mb-0">
              Facturation {{ annualPremiumPlan ? 'annuelle' : 'mensuelle' }}
            </p>
          </div>
          <form role="form" action="#" @submit.prevent="submitConsultation()">
            <div class="mb-2 p-3" style="line-height: 46px;">
              <select v-model="priceQuantityConsult" name="users" class="form-control">
                <option :value="10">10 Abonnements consultation</option>
                <option :value="20">20 Abonnements consultation</option>
                <option :value="30">30 Abonnements consultation</option>
                <option :value="40">40 Abonnements consultation</option>
                <option :value="50">50 Abonnements consultation</option>
                <option :value="60">60 Abonnements consultation</option>
                <option :value="70">70 Abonnements consultation</option>
                <option :value="80">80 Abonnements consultation</option>
                <option :value="90">90 Abonnements consultation</option>
                <option :value="100">100 Abonnements consultation</option>
              </select>
            </div>
            <div class="d-flex justify-content-center my-6">
              <input type="submit" value="valider" class="btn btn-round btn-info w-75 d-flex justify-content-center">
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- NOTIF SUCCESS -->
    <div id="consultModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="consultModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="consultModalLabel" class="modal-title text-info">Licences consultation supplémentaires</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div style="font-size: 2.5rem" class="text-success mx-auto d-flex justify-content-center"><i class="fas fa-check rotate-in-center"></i></div>
            <br><b>Votre demande a bien été transmise</b>, nous reviendrons vers vous <b class="text-info">une fois les licences activées</b><br>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END NOTIF SUCCESS -->
  </div>
</template>

<script>
  import apiSrv from '../apiSrv';

  export default {
    props: {
      user: { type: Object, required: true },
      availablePlans: { type: Object, required: true },
    },
    data() {
      return {
        currentConsultPacks: null,
        priceQuantityConsult: 10,
        priceConsultHT: null,
        priceConsultTVA: null,
        priceConsultTotal: null,
      };
    },
    computed: {
      billingPlan() { return this.user.company && this.user.company.billing_plan; },
      currentPlan() { return this.availablePlans[this.billingPlan]; },
      annualPremiumPlan() {
        return this.currentPlan.period == 'annuel';
      },
      planConsults() {
        return this.currentPlan.consults;
      },
    },
    created() {
      apiSrv.getApi(`${window.api.buy.url}/plan`, (result) => {
        // TEST
        // result = { ...result, ...this.user.company.stripePlan };
        const sub = result.subscription && result.subscription.find(item => item.plan == '10CONSULT');
        this.currentConsultPacks = sub && sub.quantity || 0;
      });
    },
    methods: {
      submitConsultation() {
        apiSrv.call(window.api.contactmail.url, 'POST', {
          name: "From myaccount premium page.",
          email: "unknown@bubbleplan.net",
          subject: "Consultation license request",
          message: `L'utilisateur souhaite prendre ${this.priceQuantityConsult} licences consultatives en plus`,
        }).then(() => {
          $('#consultModal').modal('show');
        });
      },
    },
  };
</script>
